/**
 * RpgHeader — shared screen header for the Mini-RPG sub-pages: a back button (wired to
 * the Telegram BackButton by the page), the screen title and optional mora / primogem
 * balance chips. Balances are server-authoritative — passed in, never derived here.
 */
import { CurrencyIcon } from "@melusine/shared-ui";
import { formatUnits } from "@shared/lib/format";

import styles from "../rpg.module.css";

const BackArrow = (): JSX.Element => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.9"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="m12 19-7-7 7-7" />
    <path d="M19 12H5" />
  </svg>
);

export interface RpgHeaderProps {
  readonly title: string;
  readonly onBack: () => void;
  /** Mora balance chip (shown when provided). */
  readonly mora?: number;
  /** Primogem balance chip (shown when provided). */
  readonly primogems?: number;
}

export function RpgHeader({
  title,
  onBack,
  mora,
  primogems,
}: RpgHeaderProps): JSX.Element {
  return (
    <header className={styles.header}>
      <button
        type="button"
        className={styles.backButton}
        aria-label="Назад"
        onClick={onBack}
      >
        <BackArrow />
      </button>
      <h1 className={styles.title}>{title}</h1>
      {mora !== undefined || primogems !== undefined ? (
        <div className={styles.chipRow}>
          {mora !== undefined ? (
            <span className={styles.chip}>
              <CurrencyIcon kind="mora" size={15} />
              <span className={styles.chipValue}>{formatUnits(mora)}</span>
            </span>
          ) : null}
          {primogems !== undefined ? (
            <span className={`${styles.chip} ${styles.chipPrimo}`}>
              <CurrencyIcon kind="primogem" size={15} />
              <span className={styles.chipValue}>{formatUnits(primogems)}</span>
            </span>
          ) : null}
        </div>
      ) : null}
    </header>
  );
}
